export const initFreshChat = async () => {
  if (!window.fcWidget) {
    await new Promise((resolve) => setTimeout(resolve, 100));
  }
  window.fcWidget.hide();
  window.fcWidget.on('widget:closed', () => {
    window.fcWidget.hide();
  });
};
